import React, { useState, useContext, useEffect } from 'react';
// import { Link } from 'react-router-dom';
// import { AuthContext } from '../../../context/auth';
// import image from '../../../imagenes/actividad.png';
// import { FacturaImpuesto } from './modalFacturaImpuesto';
// import { FacturaPL } from './modalFacturaPL';
// import { FacturaOtrosImpuestos } from './modalFacturaOtros';
// import { FacturaMultas } from './modalFacturaMultas';
// import { FacturaTasas } from './modalFacturaTasas';
// import { FacturaAnular } from './modalFacturaAnular';
// import { ImpFacturaEmitidas } from './modalImpFacturaEmitidas';
// import { ImpFacturaPCB } from './modalImpFacturaPCB';
// import { ImpFacturaCB } from './modalImpFacturaCB';
// import { ImpFacturaAnulada } from './modalImpFacturaAnulada';
// import { ImpFacturaPTI } from './modalImpFacturaPTI';
/* import { ImpSectorActiEconomica } from './modalImpSectorActiEconomica';
import { ImpSectorActiEconomica2 } from './modalImpSectorActiEconomica2'; */
/* import { ImprimirPatente } from './modalImprimirPatente'; */
/* import { ActualizarLicencia } from './modalActualizarLicencia'; */
/* import { ConfiguracionModulo } from './modalConfiguracionModulo'; */

function MenuFacturacion(props) {

    // const { user, logout } = useContext(AuthContext);
    // const pathname = window.location.pathname;

    // const path = pathname === '/' ? 'login' : pathname.substr(1);
    // const [activeItem, setActiveItem] = useState(path);
    const [permisos, setPermisos] = useState('');
    // const [mostrar3, setMostrar3] = useState(false);
    // const [mostrar8, setMostrar8] = useState(false);
    // const [mostrar4, setMostrar4] = useState(false);
    // const [mostrar5, setMostrar5] = useState(false);
    // const [mostrar6, setMostrar6] = useState(false);
    // const [mostrar7, setMostrar7] = useState(false);
    // const [mostrar1, setMostrar1] = useState(false);
    // const [mostrar2, setMostrar2] = useState(false);
    // const [mostrar9, setMostrar9] = useState(false);
    // const [mostrar10, setMostrar10] = useState(false);
    // const [mostrar11, setMostrar11] = useState(false);
    // const [titulo1, setTitulo1] = useState();
    // const [titulo2, setTitulo2] = useState();
    // const [tipoRep, setTipoRep] = useState();
    const [idUsuario, setIdUsuario] = useState();
    const [fechaSistema, setFechaSistema] = useState(localStorage.getItem('fechasistema'));
    const [espiritu, setEspiritu] = useState(localStorage.getItem('espiritu'));


    // let op = require('../../../../src/modulos/datos');

    useEffect(() => {

        setPermisos(JSON.parse(localStorage.getItem('permisos')));
       
        setIdUsuario(JSON.parse(localStorage.getItem('idusuario')));
       
       // setFechaSistemaetLiquidador(JSON.parse(localStorage.getItem('liquidador')));
        //setLiquida(JSON.parse(localStorage.getItem('liquida')));
        setFechaSistema(JSON.parse(localStorage.getItem('fechasistema')));
        setEspiritu(JSON.parse(localStorage.getItem('espiritu'))); 

    }, [props.permisos]);


    // const handleItemClick = (e, { name }) => setActiveItem(name);

    // const imprimirListadoAgente = () => {
    //     window.location.href = '/moduloFacturacion';
    //     var reporte = 'ListGenComercioAgente';
    //     window.open(op.reportes + "reporte=" + reporte, "Planilla", "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700");
    // }

    // const imprimirListadoCredito = () => {
    //     window.location.href = '/moduloFacturacion';
    //     var reporte = 'ListGenComercioCredito';
    //     window.open(op.reportes + "reporte=" + reporte, "Planilla", "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700");
    // }

    // const handleCancelaImpSector = () => {
    //     window.location.href = '/moduloFacturacion';
    //     setMostrar3(false);

    // }

    // const handleCancelaImpSector3 = () => {
    //     window.location.href = '/moduloFacturacion';
    //     setMostrar3(false);

    // }

    /* const handleCancelaImpPatente = () => {
        //window.location.href = '/actividadEconomica';
        setMostrar6(false);

    } */

    // const handleCancelaImpSector2 = () => {
    //     window.location.href = '/moduloFacturacion';
    //     setMostrar4(false);

    // }

    // const handleCancelaImpSectorMulta = () => {
    //     window.location.href = '/moduloFacturacion';
    //     setMostrar6(false);

    // }

    // const handleCancelaImpSectorAnular = () => {
    //     window.location.href = '/moduloFacturacion';
    //     setMostrar7(false);

    // }

    // const handleCancelaImpSectorFactEm = () => {
    //     window.location.href = '/moduloFacturacion';
    //     setMostrar1(false);

    // }

    // const handleCancelaImpSectorFactPCB = () => {
    //     window.location.href = '/moduloFacturacion';
    //     setMostrar2(false);

    // }

    // const handleCancelaImpSectorFactCB = () => {
    //     window.location.href = '/moduloFacturacion';
    //     setMostrar9(false);

    // }

    // const handleCancelaImpSectorFactAnulada = () => {
    //     window.location.href = '/moduloFacturacion';
    //     setMostrar10(false);

    // }

    // const handleCancelaImpSectorFactPTI = () => {
    //     window.location.href = '/moduloFacturacion';
    //     setMostrar11(false);

    // }

    // const handleCancelaImpSectorTasas = () => {
    //     window.location.href = '/moduloFacturacion';
    //     setMostrar5(false);

    // }

    /* const handleCancelaRenovacionLic = () => {
        window.location.href = '/moduloFacturacion';
        setMostrar5(false);

    } */

    // const handleCancelaSolicitudLic = () => {
    //     window.location.href = '/moduloFacturacion';
    //     setMostrar6(false);

    // }

    // const handleImpSector = (tiprep) => (event) => {
    //     setTipoRep(tiprep)
    //     if (tiprep === '1') {
    //         setTitulo1('Impresión de Factura');
    //         setTitulo2('Facturación de Impuesto');
    //     } else if (tiprep === '2') {
    //         setTitulo1('Impresión de Factura');
    //         setTitulo2('Facturación de Publicidad y Licores');
    //     } else if (tiprep === '3') {
    //         setTitulo1('Impresión General de Contribuyentes por Tipo de Actividad');
    //         setTitulo2('Listado Contribuyentes por Tipo de Actividad');
    //     }
    //     setMostrar3(true)
    // }

    // const handleImpSector2 = (tiprep) => (event) => {
    //     setTipoRep(tiprep)
    //     if (tiprep === '1') {
    //         setTitulo1('Impresión de Factura');
    //         setTitulo2('Facturación de Otros Impuestos');
    //     }
    //     setMostrar4(true)
    // }

    // const handleImpSectorMulta = (tiprep) => (event) => {
    //     setTipoRep(tiprep)
    //     if (tiprep === '2') {
    //         setTitulo1('Impresión de Factura');
    //         setTitulo2('Facturación de Multas');
    //     }
    //     setMostrar6(true)
    // }

    // const handleImpSectorAnular = (tiprep) => (event) => {
    //     setTipoRep(tiprep)
    //     if (tiprep === '1') {
    //         setTitulo1('Anular Facturas');
    //         setTitulo2('Control de Visitas');
    //     }
    //     setMostrar7(true)
    // }

    // const handleImpSectorTasas = (tiprep) => (event) => {
    //     setTipoRep(tiprep)
    //     if (tiprep === '1') {
    //         setTitulo1('Impresión de Factura');
    //         setTitulo2('Facturación de Tasas');
    //     }
    //     setMostrar5(true)
    // }

    // const handleImpSector3 = (tiprep) => (event) => {
    //     setTipoRep(tiprep)
    //     if (tiprep === '2') {
    //         setTitulo1('Impresión de Factura');
    //         setTitulo2('Facturación de Publicidad y Licores');
    //     }
    //     setMostrar8(true)
    // }

    // const handleImpSectorFactEmi = (tiprep) => (event) => {
    //     setTipoRep(tiprep)
    //     if (tiprep === '1') {
    //         setTitulo1('Impresión General de Facturas Emitidas');
    //         setTitulo2('Facturas Emitidas');
    //     }
    //     setMostrar1(true)
    // }

    // const handleImpSectorFactPCB = (tiprep) => (event) => {
    //     setTipoRep(tiprep)
    //     if (tiprep === '1') {
    //         setTitulo1('Impresión General de Facturas por Cobrar');
    //         setTitulo2('Facturas por Cobrar');
    //     }
    //     setMostrar2(true)
    // }

    // const handleImpSectorFactCB = (tiprep) => (event) => {
    //     setTipoRep(tiprep)
    //     if (tiprep === '1') {
    //         setTitulo1('Impresión General de Facturas Cobradas');
    //         setTitulo2('Facturas Cobradas');
    //     }
    //     setMostrar9(true)
    // }

    // const handleImpSectorFactAnulada = (tiprep) => (event) => {
    //     setTipoRep(tiprep)
    //     if (tiprep === '2') {
    //         setTitulo1('Impresión General de Facturas Anuladas');
    //         setTitulo2('Facturas Anuladas');
    //     }
    //     setMostrar10(true)
    // }

    // const handleImpSectorFactPTI = (tiprep) => (event) => {
    //     setTipoRep(tiprep)
    //     if (tiprep === '1') {
    //         setTitulo1('Impresión General de Facturas por Tipo de Impuesto');
    //         setTitulo2('Facturas por Tipo de Impuesto');
    //     }
    //     setMostrar11(true)
    // }

    // const handleImpPatente = () => (event) => {
    //     setMostrar7(true)
    // }

    // const handleRenovacionLic = () => {
    //     setMostrar5(true)
    // }

    // const handleSolicitudLic = () => {
    //     setMostrar6(true)
    // }

    // const abrirConfiModulo = () => {
    //     setMostrar7(true)
    // }

    // const handleCancelaConfi = () => {
    //     setMostrar7(false)
    // }

    const menu =  ''


    return menu;

} export default MenuFacturacion;